export enum Securities {
  List = 'securities.list',
  Quotes = 'securities.quotes',
  Security = 'securities.security',
}
